import { Button, Typography } from 'components/UI'
import './teamsSection.css'

type Props = {
	openModal: (title: string, description: string) => void
}

const TeamsSection = ({ openModal }: Props) => (
	<div class='team-card mt-14 rounded-md p-5'>
		<Typography
			class='mb-4'
			color='text-black-100'
			text='Introducing Teams'
			variant='label1'
		/>

		<Typography
			class='mb-2 mt-2'
			text='Maximize productivity with team-centric features'
			variant='text2'
		/>

		<div class='flex justify-end'>
			<Button
				backgroundColor='bg-black-900 hover:bg-black-800'
				onClick={() =>
					openModal(
						'Teams',
						'Maximize productivity with team-centric features for better collaboration on your dApps. Manage roles, share code seamlessly, and stay in sync with real-time updates—all in one centralized space. Stay tuned for more on how Teams will elevate your development experience!'
					)
				}
				text='Coming Soon'
				textColor='text-black-100'
			/>
		</div>
	</div>
)

export { TeamsSection }
